import * as React from 'react'
import { Loading, WidgetWrapper } from 'uxp/components'
import { IUIPropertyDefinitionMap, IWidgetTemplateInstanceProps, IWidgetTemplateProps, PropertyPath, addToPath, registerCardTemplate, registerMobileCardTemplate } from '../../../common/common'
import { generateIconProp } from '../../../common/icon-selector/IconEditor'
import { SelectableItem, selectUIProps, selectUIPropsForMobileTempaltes } from '../../../common/SelectableItem'
import { ContainerProperty, extractContainerProperties } from '../../../common/ui-props/ContainerProperty'

import './custom-ui-card.scss'
import { CustomUI, CustomUIProperty } from '../../../common/custom-ui/CustomUI'
import { hasValue, parseValue, updateParentUIPropsWithDefaultWidgetUIProps } from '../../../../util'
import { IContextData, useInitialContextData } from '../../../../hooks/useContextData'

const XPR: React.ForwardRefExoticComponent<React.RefAttributes<IWidgetTemplateInstanceProps> & IWidgetTemplateProps> = React.forwardRef((props, ref) => {

    let uiProps = props?.uiProps || {};
    let markup = { ...uiProps?.markup }
    if (!markup?.web) markup.web = ''
    if (!markup?.mobile) markup.mobile = ''

    uiProps.markup = markup
    const parentUIProps = updateParentUIPropsWithDefaultWidgetUIProps(props.parentUIProps, uiProps, props.index)
    const dataSourcesPath: PropertyPath = props.designer?.isMobile ? addToPath('fields', props.index, 'props', 'uiProps', 'datasources') : 'datasources'

    const XPRProps: IUIPropertyDefinitionMap = {
        "container": ContainerProperty({
            background: {
                color: "#ffffff",
                image: {
                    image: "",
                    position: "",
                    size: "",
                },
            }
        }),
        'markup': CustomUIProperty('Custom UI', { mobile: '', web: '' }, dataSourcesPath),
    }

    const [contextData, setContextData] = React.useState<IContextData>({})
    const [loading, setLoading] = React.useState(false)

    const { isLoading, initialContextData } = useInitialContextData(props, [props?.uiProps?.markup?.binding])

    let { styles: containerStyles } = extractContainerProperties(uiProps.container);

    const webContent = (props.designer && (props.designer.mode == 'preview' || props.designer.mode == 'thumbnail')) ? markup?.web || '' : parseValue(markup?.web || '', contextData)

    React.useEffect(() => {
        setContextData(initialContextData)
        setLoading(isLoading)
    }, [isLoading, initialContextData])

    return (
        <WidgetWrapper className='custom-ui-card-widget-template wd-widget-wrapper'>
            <div className="bg" style={containerStyles}></div>
            <SelectableItem
                style={{ left: 0, right: 0, top: 0, bottom: 0 }}
                designer={props.designer}
                props={selectUIPropsForMobileTempaltes(parentUIProps, XPRProps, props.index, {}, 'container')}
                elementId={props.instanceId}
            >
                <div className='container'>
                    <SelectableItem
                        designer={props.designer}
                        props={selectUIPropsForMobileTempaltes(parentUIProps, XPRProps, props.index, { datasources: dataSourcesPath }, 'markup')}
                        elementId={props.instanceId}
                    >
                        {loading
                            ? <Loading />
                            : <CustomUI mode={props.designer?.mode} mobile={markup.mobile} web={webContent} />
                        }
                    </SelectableItem>
                </div>
            </SelectableItem>

        </WidgetWrapper>
    )
})

registerCardTemplate({
    id: 'custom-ui-card',
    name: 'Custom Interface Card',
    description: 'Describe a custom interface in a markup language',
    template: XPR,
    icon: generateIconProp('box'),
    complexity: 'easy',
});

registerMobileCardTemplate({
    id: 'custom-ui-card',
    template: XPR,
    name: 'Custom UI Section',
    description: 'Describe a custom interface with a special interface language'
})